{
  "eyebrow": "Je bent erin",
  "title": "Welkom bij Done-it, {{company}}.",
  "titleGeneric": "Welkom bij Done-it.",
  "sub": "Je 30-daagse proefperiode van {{plan}} is actief. Drie dingen om nu te doen.",
  "subGeneric": "Je account is actief. Drie dingen om nu te doen.",
  "next1": {
    "title": "Download de mobiele app",
    "desc": "Stuur de installatielink naar je team via sms of e-mail.",
    "cta": "Stuur uitnodigingslink"
  },
  "next2": {
    "title": "Nodig je team uit",
    "desc": "Importeer medewerkers in bulk vanuit CSV, of voeg ze één voor één toe.",
    "cta": "Open beheer"
  },
  "next3": {
    "title": "Bekijk een tour van 4 minuten",
    "desc": "Zie hoe je je eerste project en locaties opzet.",
    "cta": "Bekijk video"
  },
  "cta": "Ga naar dashboard",
  "receipt": "Een ontvangstbewijs en onboarding-e-mail zijn onderweg naar {{email}}.",
  "receiptGeneric": "Een ontvangstbewijs en een startmail zijn onderweg.",
  "fallbacks": {
    "company": "je bedrijf",
    "plan": "je abonnement",
    "inbox": "je inbox"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "Je {{plan}}-account is actief — voor altijd gratis. Nog drie dingen te doen."
}
